import { createContext } from "react";
import {
  ExchangeMetadata,
  ExchangesMetadata,
  ExchangeTag,
  QueryStatus,
} from "@shared/types";

export const ExchangesMetadataContext = createContext<
  | {
      exchangesMetadata: ExchangesMetadata | undefined;
      getExchangesMetadataStatus: QueryStatus<ExchangesMetadata>;
      getExchangeMetadata: (exchange?: string) => ExchangeMetadata | undefined;
      getExchangePriceFactorLimits: (exchange?: string) => {
        min: number;
        max: number;
      };
      isSuccess?: boolean;
      getAlternativeUsdPairs: (accountId?: number) => string[] | undefined;
      exchanges: string[];
      getExchangeTag: (exchange?: string) => ExchangeTag | undefined;
      exchangeToDisplayName: Record<string, string>;
      getIsFree: (exchange?: string) => boolean;
    }
  | undefined
>(undefined);
